import * as React from "react"
import H4 from "../../atoms/typography/H4"

const AccountDeletedModalContent: React.FunctionComponent = () => {
  return (
    <div>
      <H4 textAlign="center">Your account has been deleted.</H4>
    </div>
  )
}

export default AccountDeletedModalContent
